@if (contentlet()) {
<div
  class="default-video-class"
  [ngStyle]="{ 'height.px': (getVideoHeight$(contentlet()) | async) }"
  [ngClass]="getVideoClasses(contentlet())"
>
  @if (buildVideoSrc() | async; as videoSrc) {
  <video
    controls
    width="100%"
    height="100%"
    [src]="videoSrc"
    playsInline
    [autoplay]="contentlet().autoPlayVideo"
    [muted]="contentlet().mute"
    class="dotcms-video"
    style="display: block"
  ></video>
  }
</div>
} @if(content()){
<video controls width="100%" height="100%" [src]="$srcURL()" playsInline></video>
}
